import { Nav } from '@/components/yunti/Nav';
import { Hero } from '@/components/yunti/Hero';
import { BrandIntro } from '@/components/yunti/BrandIntro';
import { Perspective } from '@/components/yunti/Perspective';
import { TheWay } from '@/components/yunti/TheWay';
import { Products } from '@/components/yunti/Products';
import { Contact } from '@/components/yunti/Contact';
import { Footer } from '@/components/yunti/Footer';

export function SiteSections() {
  return (
    <>
      <Nav />
      <main>
        <Hero />
        <BrandIntro />
        <Perspective />
        <TheWay />
        <Products />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
